import React from "react";
import { FormattedMessage } from "react-intl";

export default [
    {
        name: "name",
        label: "Name",
        type: "string",
        errorMessage: "Name must be in English or Arabic letters with minimum length of 3",
        validation: {
            pattern: /^[\u0621-\u064A\u0660-\u0669a-zA-Z ]+$/,
            required: true,
        },
    },
    {
        name: "phoneNumber",
        label: "Phone Number",
        type: "string",
        helpText: <FormattedMessage id="supplier-form.help-txt-phone-number" />,
        errorMessage: <FormattedMessage id="supplier-form.err-msg-phone-number" />,
        validation: {
            pattern: /^0\d{10}$/,
            required: true,
        },
    },
    // {
    //     name: "driverIds",
    //     label: "Drivers",
    //     type: "list",
    //     helpText: "Drivers",
    //     url: "/drivers",
    //     filterValue: "name",
    //     isMultiple: true,
    //     entityName: "drivers",
    //     include: true,
    // },
    // {
    //     name: "truckIds",
    //     label: "Trucks",
    //     type: "list",
    //     helpText: "Trucks",
    //     url: "/trucks",
    //     filterValue: "plateNumber",
    //     isMultiple: true,
    //     entityName: "trucks",
    //     include: true,
    // },
];
